import React, { useState, useEffect } from 'react';
import { Card, Button } from 'react-bootstrap';
import FeedbackActionForm from './FeedbackActionForm';

const MessageModal = (props) => {
    const [message, setMessage] = useState(props.message)

    return (
        <div>
            <Card>
                <Card.Header>
                    <div>
                        <h3 className="m-0">{message.firstName} {message.lastName}</h3>
                        <p className="m-0">{message.email}</p>
                        <p className="m-0">{getDate(message.createdAt)}</p>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Card.Title>
                        <p style={{ whiteSpace: 'pre-line' }}>{message.message}</p>
                    </Card.Title>
                    {/* <Card.Text>
                        With supporting text below as a natural lead-in to additional content.
                    </Card.Text> */}

                </Card.Body>
            </Card>
            <FeedbackActionForm message={message} updateMessage={props.updateMessage} />

        </div>
    )
}

function getDate(date) {
    var a = new Date(date);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var day = a.getDate();
    return (`${month} ${day}, ${year}`)
}

export default MessageModal
